import { defineMessages } from 'react-intl';

export default defineMessages({
    requiredMessage: {
        id: 'tfpa.propertyDetails.views.messages.requiredMessage',
        defaultMessage: 'This is a required field.'
    }

});